/**
 * Defines border designs.
 * @public
 */
enum BorderDesign {
	/**
	 * A solid border color dependent on the theme.
	 * @public
	 */
	Solid = "Solid",

	/**
	 * Specifies no border.
	 * @public
	 */
	None = "None",
}

export default BorderDesign;
